/* eslint-env browser */
import DocumentCategories from "./DocumentCategories";

/*
  TODO: The file structure of the Constants service needs to be fixed to be in line wiht our system.
*/

export default DocumentCategories;
